module.exports = "/_next/static/images/clapping_hands-9a11ba7ed45307b836d54550e901c26f.png";